<template>
  <div
    class="user_wrap"
  >
    <div class="top_header">
      <section
        v-if="acc"
        class="profile-card"
      >
        <div class="profile-main">
          <div class="user_header">
            <img
              :src="avatarSrc"
              alt=""
            >
          </div>
          <div class="user_name">
            <div class="user_title_row">
              <p class="user_mobile">
                {{ userMobile }}
              </p>
              <img
                :src="vip?.img"
                alt=""
                class="vip_img"
              >
              <!--   <span
                v-if="vipName"
                class="vip-badge"
              >
                {{ vipName }}
              </span> -->
            </div>
            <div class="profile-meta">
              {{ $t('d.creditscore') }}:
              <strong
                class="user_mobile"
                style="font-size: 12px;"
              >{{ acc?.credit }}</strong>
            </div>
            <div class="invite-row">
              <span>{{ $t('d.code') }}: 
                <strong
                  class="user_mobile"
                  style="font-size: 12px;"
                >{{ inviteCode }}</strong></span>
              <button
                type="button"
                class="copy-btn"
                @click.stop="copyYaocode"
              >
                {{ $t('invest_bank.copy') }}
              </button>
            </div>
          </div>
          <button
            type="button"
            class="msg"
            :aria-label="$t('user.setting')"
            @click="$router.push('/set')"
          >
            <van-icon
              name="setting-o"
              size="22"
            />
          </button>
        </div>
      </section>

      <section class="user_money">
        <div class="balance-main">
          <div class="balance-copy">
            <p>{{ $t('d.balance') }}</p>
            <div class="balance-value-row">
              <strong>{{ formatAmount(data.money) }}</strong>
              <button
                v-if="fundsFreezeState === 1"
                type="button"
                class="freeze-countdown"
                @click="showFundsFreezeHelp"
              >
                {{ $t('d.fundsFreezeCountdown') }}：{{ formatCountdown(fundsFreezeRemaining) }}
              </button>
            </div>
          </div>
          <button
            type="button"
            class="recharge-btn"
            :aria-label="$t('income.title')"
            @click="$router.push('/invest')"
          >
            <van-icon
              name="add"
              size="24"
            />
          </button>
        </div>
        <div class="money_num">
          <button
            type="button"
            class="stat-cell freeze-funds-cell"
            :class="{ 'is-frozen': fundsFreezeState !== 0 }"
            @click="showFundsFreezeHelp"
          >
            <p>{{ formatAmount(data.frozenmoney) }}</p>
            <span>{{ $t('d.frozen') }}</span>
          </button>
          <div class="stat-cell">
            <p>{{ formatAmount(data.reward) }}</p>
            <span>{{ $t('d.todayrewards') }}</span>
          </div>
        </div>
      </section>
    </div>

    <section class="vip_group">
      <div class="vip_group_txt">
        <p class="vip_group_title">
          {{ $t('membershipBanner.title') }}
        </p>
        <p class="vip_group_subtitle">
          {{ $t('membershipBanner.subtitle') }}
        </p>
      </div>
    </section>

    <div class="list">
      <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/membership-card')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="vip-card-o"
              size="20"
            />
            <span class="custom-title">{{ $t('membershipCard.menuTitle') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/invest')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="credit-pay"
              size="20"
            />
            <span class="custom-title">{{ $t('income.title') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/cash')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="share-o"
              size="20"
            />
            <span class="custom-title">{{ $t('user.withdraw') }}</span>
          </span>
        </template>
      </van-cell>
      <!-- <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/ordering')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="gem-o"
              size="20"
            />
            <span class="custom-title">{{ $t('grapHome.taskOrder') }}</span>
          </span>
        </template>
      </van-cell> -->
      <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/order')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="todo-list-o"
              size="20"
            />
            <span class="custom-title">{{ $t('grapHome.luckyOrder') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/cashlist')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="certificate"
              size="20"
            />
            <span class="custom-title">{{ $t('user.withdrawalRecord') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/funds')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="debit-pay"
              size="20"
            />
            <span class="custom-title">{{ $t('pro2.transactionhis') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/notice')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="smile-comment-o"
              size="20"
            />
            <span class="custom-title">{{ $t('notice.message') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/kefu')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="service"
              size="20"
            />
            <span class="custom-title">{{ $t('webindex.custserver') }}</span>
          </span>
        </template>
      </van-cell>

<!--      <div class="logout-wrap">
        <button
          type="button"
          class="history_coupon"
          @click="logout"
        >
          <span>{{ $t('safe.signOut') }}</span>
        </button>
      </div> -->
    </div>

    <van-popup
      v-model="show"
      round
      class="notice-popup"
    >
      {{ msg }}
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import {
  Icon,
  Cell,
  CellGroup,
  Popup,
  Dialog,
} from "vant";

Vue.use(Cell).use(CellGroup).use(Icon).use(Popup).use(Dialog);

export default {
  name: "User",
  components: {
  },
  data() {
    return {
      lang: this.$i18n.locale || "zh_cn",
      data: {},
      islogin: false,
      show_kefu: false,
      msg_show: true,
      vip: null,
      acc: null,
      msg: null,
      show: false,
      app: null,
      eye: 1,
      freezeNow: Date.now(),
      freezeLoadedAt: Date.now(),
      freezeTimer: null,
    };
  },
  computed: {
    avatarSrc() {
      return this.app && this.app.fuli1 ? this.app.fuli1 : '';
    },
    userMobile() {
      return this.acc && this.acc.mobile ? this.acc.mobile : '--';
    },
    vipName() {
      return this.acc && this.acc.vip ? this.acc.vip.name : '';
    },
    inviteCode() {
      var code = this.data && this.data.yaocode;
      return code === undefined || code === null || code === '' ? '--' : code;
    },
    fundsFreezeState() {
      return parseInt(this.data && this.data.funds_freeze_state, 10) || 0;
    },
    fundsFreezeRemaining() {
      if (this.fundsFreezeState !== 1) {
        return 0;
      }
      var serverRemaining = parseInt(this.data && this.data.funds_freeze_remaining, 10) || 0;
      var elapsed = Math.floor((this.freezeNow - this.freezeLoadedAt) / 1000);
      return Math.max(0, serverRemaining - elapsed);
    },
    frozenFundsDisplay() {
      if (this.fundsFreezeState === 2) {
        return this.$t('d.fundsFrozen');
      }
      return this.formatAmount(this.data.frozenmoney);
    }
  },
  created() {
    this.$parent.footer('user');
  },
  mounted() {
    this.islogin = localStorage.getItem('token') != null;
    if (!this.islogin) {
      this.$router.push("/login");
    }
    this.start();
    document.body.addEventListener(
      "scroll",
      () => {
        if (!this.show_kefu) {
          return;
        }
        this.show_kefu = false;
      },
      false
    );
    document.addEventListener(
      "click",
      (ev) => {
        if (ev.target.className != "kefu_img") {
          this.show_kefu = false;
        }
      },
      false
    );
  },
  beforeDestroy() {
    if (this.freezeTimer) {
      clearInterval(this.freezeTimer);
      this.freezeTimer = null;
    }
  },
  methods: {
    sync() {
      Fetch("/index/sync", {}, null, false).then((r) => {
        var data = r.data;
        if (data && data.length > 0) {
          this.msg = data[0].content;
          this.show = true;
          setTimeout(() => {
            Fetch('/user/notice_view', {
              id: data[0].id
            });
          }, 2000);
        }
      });
    },
    kefu_to() {
      var link = this.app && this.app.kefu_link;
      if (link) {
        window.location.href = link;
      }
    },
    downapp() {
      top.location.href = '/app.apk';
    },
    copy() {
      this.$toast({
        background: "#07c160",
        message: this.$t('invest_qrcode.copySucceeded'),
      });
    },
    copyYaocode() {
      var yaocode = this.data && this.data.yaocode;
      this.copyText(yaocode === undefined || yaocode === null ? '' : String(yaocode));
    },
    copyText(text) {
      if (!text) {
        return;
      }
      if (this.copyTextBySelection(text)) {
        this.copy();
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.copy();
        }).catch(() => {});
      }
    },
    copyTextBySelection(text) {
      var input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', 'readonly');
      input.style.position = 'fixed';
      input.style.left = '-9999px';
      input.style.top = '0';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.focus();
      input.select();
      input.setSelectionRange(0, input.value.length);
      var copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (e) {
        copied = false;
      }
      document.body.removeChild(input);
      return copied;
    },
    formatAmount(value) {
      var amount = parseFloat(value);
      if (!isFinite(amount)) {
        return '0';
      }
      return amount.toFixed(2);
    },
    formatCountdown(seconds) {
      var value = Math.max(0, parseInt(seconds, 10) || 0);
      var hours = Math.floor(value / 3600);
      var minutes = Math.floor((value % 3600) / 60);
      var remainingSeconds = value % 60;
      return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(remainingSeconds).padStart(2, '0');
    },
    showFundsFreezeHelp() {
      if (this.fundsFreezeState !== 0) {
        Dialog.alert({ message: this.$t('d.fundsFreezeContact') });
      }
    },
    refreshUserInfo() {
      return Fetch('/user/info').then((r) => {
        this.data = r.data;
        this.acc = r.data;
        this.freezeLoadedAt = Date.now();
        this.freezeNow = this.freezeLoadedAt;
        if (r.data.vip) {
          this.vip = r.data.vip;
        }
        this.startFreezeTimer();
      });
    },
    startFreezeTimer() {
      if (this.freezeTimer) {
        clearInterval(this.freezeTimer);
        this.freezeTimer = null;
      }
      if (this.fundsFreezeState !== 1) {
        return;
      }
      this.freezeTimer = setInterval(() => {
        this.freezeNow = Date.now();
        if (this.fundsFreezeRemaining <= 0) {
          clearInterval(this.freezeTimer);
          this.freezeTimer = null;
          this.refreshUserInfo();
        }
      }, 1000);
    },
    start() {
      Fetch('/index/webconfig').then((r) => {
        this.app = r.data;
      });
      this.refreshUserInfo();
      setTimeout(() => {
        this.sync();
      }, 2000);
    },
    logout() {
      localStorage.removeItem('token');
      this.$router.replace("/");
    }
  }
};
</script>

<style lang="less" scoped>
.user_wrap {
  --accent: #ff5d7a;
  --accent-strong: #ff4f70;
  --accent-soft: #fff1f5;
  --accent-line: #ffdbe4;
  --text: #16223a;
  --muted: #5d677a;
  --shadow: 0 12px 28px rgba(255, 93, 122, 0.13);
  min-height: 100vh;
  padding: 0 0 104px;
  background: #fff;
  color: var(--text);
  box-sizing: border-box;
  background: linear-gradient(180deg, #ff748f 0%, #ff5574 100%);
}

button {
  border: 0;
  font: inherit;
  cursor: pointer;
}

.top_header {
  width: 100%;
  padding: 14px 14px 8px;
  // background: linear-gradient(180deg, #ff748f 0%, #ff5574 100%);
  box-sizing: border-box;
}

.profile-card,
.user_money,
.vip_group,
.list {
  overflow: hidden;
  border-radius: 14px;
  border: 1px solid var(--accent-line);
  background: #fff;
  box-shadow: var(--shadow);
  box-sizing: border-box;
}

.profile-card {
  border-color: rgba(255, 255, 255, 0.34);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.06) 100%);
  box-shadow: 0 10px 22px rgba(184, 35, 64, 0.16);
}

.profile-main {
  min-height: 106px;
  padding: 18px 16px;
  display: flex;
  align-items: center;
  position: relative;
  box-sizing: border-box;
}

.user_header {
  width: 80px;
  height: 80px;
  flex: 0 0 80px;
  overflow: hidden;
  border-radius: 12px;
  border: 3px solid rgba(255, 255, 255, 0.86);
  background: #fff0f4;
  box-shadow: 0 10px 22px rgba(171, 33, 62, 0.2);
}

.user_header img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.user_name {
  min-width: 0;
  flex: 1;
  margin-left: 14px;
  padding-right: 42px;
}

.user_title_row {
  min-width: 0;
  display: flex;
  align-items: center;
}

.user_mobile {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.vip-badge {
  flex: 0 0 auto;
  margin-left: 10px;
  padding: 3px 10px;
  border-radius: 16px;
  color: var(--accent);
  background: rgba(255, 255, 255, 0.92);
  font-size: 12px;
  font-weight: 800;
  line-height: 16px;
  white-space: nowrap;
}

.profile-meta,
.invite-row {
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 12px;
  line-height: 18px;
}

.profile-meta {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.invite-row {
  min-width: 0;
  display: flex;
  align-items: center;
}

.invite-row span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.copy-btn {
  height: 26px;
  flex: 0 0 auto;
  margin-left: 8px;
  padding: 0 12px;
  border-radius: 9px;
  border: 1px solid rgba(255, 255, 255, 0.72);
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  line-height: 26px;
  box-sizing: border-box;
}

.msg {
  width: 34px;
  height: 34px;
  position: absolute;
  top: 17px;
  right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.28);
}

.user_money {
  margin-top: 12px;
}

.balance-main {
  min-height: 84px;
  padding: 18px 24px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-bottom: 1px solid #f4edf0;
  box-sizing: border-box;
}

.balance-copy {
  min-width: 0;
}

.balance-copy p {
  margin: 0 0 8px;
  color: var(--muted);
  font-size: 14px;
  line-height: 22px;
}

.balance-copy strong {
  display: block;
  overflow: hidden;
  color: var(--accent);
  font-size: 18px;
  font-weight: 800;
  line-height: 22px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.recharge-btn {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  background: linear-gradient(180deg, #ff7892 0%, #ff5574 100%);
  box-shadow: 0 10px 18px rgba(255, 85, 116, 0.28);
}

.money_num {
  padding: 12px 12px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  background: linear-gradient(180deg, #fff 0%, #fff8fa 100%);
  box-sizing: border-box;
}

.stat-cell {
  min-width: 0;
  min-height: 60px;
  padding: 10px 8px;
  border-radius: 11px;
  background: var(--accent-soft);
  text-align: center;
  box-sizing: border-box;
}

.freeze-funds-cell {
  border: 0;
  cursor: default;
  font: inherit;
  text-align: center;
}

.freeze-funds-cell.is-frozen {
  cursor: pointer;
}

.stat-cell p {
  margin: 0;
  overflow: hidden;
  color: var(--accent);
  font-size: 14px;
  font-weight: 800;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.stat-cell span {
  display: block;
  margin-top: 5px;
  color: #6d7688;
  font-size: 12px;
  line-height: 18px;
}

.vip_group {
  min-height: 74px;
  margin: 14px 16px 0;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
}

.vip_group_txt {
  min-width: 0;
  flex: 1;
  color: var(--accent-strong);
  font-size: 14px;
  font-weight: 800;
  line-height: 22px;
  word-break: break-word;
}

.vip_group_img {
  width: 64px;
  height: 40px;
  flex: 0 0 64px;
  margin-left: 14px;
  object-fit: contain;
}

.list {
  margin: 14px 16px 0;
  padding: 8px 14px 12px;
  box-shadow: 0 10px 24px rgba(255, 93, 122, 0.09);
}

/deep/ .van-cell {
  min-height: 50px;
  padding: 0;
  display: flex;
  align-items: center;
  background: transparent;
  color: var(--text);
  line-height: 50px;
}

/deep/ .van-cell:not(:last-of-type) {
  border-bottom: 1px solid #f2edf0;
}

/deep/ .van-cell::after {
  display: none;
}

/deep/ .van-cell__title {
  min-width: 0;
}

/deep/ .van-cell__right-icon {
  position: absolute;
  top: 50%;
  right: 0;
  margin: 0;
  transform: translateY(-50%);
  color: #a9b0bd;
  font-size: 14px;
  line-height: 1;
}

.menu-title {
  min-width: 0;
  display: flex;
  align-items: center;
}

.menu-icon {
  flex: 0 0 auto;
  margin-right: 12px;
  color: var(--accent);
}

.custom-title {
  overflow: hidden;
  color: var(--text);
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.logout-wrap {
  padding-top: 18px;
}

.history_coupon {
  width: 100%;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  border: 1px solid rgba(255, 93, 122, 0.28);
  background: var(--accent-soft);
  color: var(--accent);
  font-size: 14px;
  font-weight: 800;
  line-height: 20px;
}

/deep/ .notice-popup {
  width: 70%;
  padding: 15px;
  border: 1px solid rgba(255, 93, 122, 0.18);
  background: #fff;
  color: var(--text);
  font-weight: 700;
  line-height: 30px;
  box-sizing: border-box;
  box-shadow: 0 12px 28px rgba(255, 93, 122, 0.18);
}

@media screen and (max-width: 374px) {
  .top_header {
    padding-right: 12px;
    padding-left: 12px;
  }

  .vip_group,
  .list {
    margin-right: 12px;
    margin-left: 12px;
  }

  .profile-main {
    padding: 14px;
  }

  .user_header {
    width: 56px;
    height: 56px;
    flex-basis: 56px;
  }

  .user_name {
    margin-left: 12px;
    padding-right: 38px;
  }

  .balance-copy strong {
    font-size: 14px;
  line-height: 28px;
}

.balance-value-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.freeze-countdown {
  padding: 4px 7px;
  border: 0;
  border-radius: 8px;
  background: #fff0f4;
  color: var(--accent);
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
}

  .vip_group_img {
    width: 50px;
    height: 50px;
    flex-basis: 50px;
  }
}
.vip_img{
	height: 16px;
	margin-left: 10px;
	-o-object-fit: contain;
	object-fit: contain;
}

.user_wrap {
  --accent: #f3c99e;
  --accent-strong: #f5cfa8;
  --accent-soft: #302a27;
  --accent-line: #75654f;
  --text: #f4ece7;
  --muted: #b28d6c;
  --shadow: 0 10px 24px rgba(0, 0, 0, .2);
  min-height: 100vh;
  padding-bottom: calc(84px + env(safe-area-inset-bottom));
  background: #201c1d;
  color: var(--text);
}

.top_header {
  padding: 12px 10px 6px;
}

.profile-card,
.user_money,
.vip_group,
.list {
  border: 1px solid var(--accent-line);
  border-radius: 9px;
  background: linear-gradient(110deg, #232323, #303030);
  box-shadow: var(--shadow);
}

.profile-card {
  border-color: #88765d;
  background: linear-gradient(120deg, #332a26, #272424 66%, #312722);
}

.profile-main {
  min-height: 96px;
  padding: 14px;
}

.user_header {
  width: 70px;
  height: 70px;
  flex-basis: 70px;
  border: 2px solid var(--accent);
  border-radius: 9px;
  background: #272424;
  box-shadow: 0 7px 18px rgba(0, 0, 0, .3);
}

.user_name {
  margin-left: 12px;
  padding-right: 38px;
}

.user_mobile {
  color: var(--text);
}

.profile-meta,
.invite-row {
  margin-top: 6px;
  color: #d7c5b4;
}

.vip-badge {
  color: #5a4839;
  background: linear-gradient(120deg, #f5cfa8, #dbab73);
}

.copy-btn {
  height: 24px;
  border-color: #a78b6c;
  border-radius: 6px;
  background: rgba(243, 201, 158, .12);
  color: var(--accent);
  line-height: 22px;
}

.msg {
  top: 14px;
  right: 14px;
  color: var(--accent);
  background: #322b28;
  box-shadow: inset 0 0 0 1px #806e59;
}

.user_money {
  margin-top: 10px;
}

.balance-main {
  min-height: 78px;
  padding: 14px 18px;
  background: transparent;
  border-bottom-color: #4a4038;
}

.balance-copy p,
.stat-cell span {
  color: #c7af99;
}

.balance-copy strong,
.stat-cell p {
  color: var(--accent);
}

.recharge-btn {
  width: 38px;
  height: 38px;
  flex-basis: 38px;
  color: #5a4839;
  background: linear-gradient(120deg, #f5cfa8, #dbab73);
  box-shadow: 0 7px 16px rgba(0, 0, 0, .25);
}

.money_num {
  padding: 10px;
  gap: 8px;
  background: rgba(27, 24, 24, .34);
}

.stat-cell {
  min-height: 58px;
  border: 1px solid #4d423a;
  border-radius: 7px;
  background: #282524;
}

.balance-value-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
}

.freeze-countdown {
  padding: 3px 7px;
  border: 1px solid #6d5d4e;
  border-radius: 6px;
  background: #322b28;
  color: var(--accent);
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
}

.vip_group {
  // min-height: 84px;
  margin: 10px ;
  padding: 0;
  display: flex;
  align-items: center;
  border: 0;
  border-radius: 42px;
  background-color: #282828;
  background-image: url('../images/ban6/user-bg.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-shadow: none;
}

.vip_group_txt {
  min-width: 0;
  width: 260px;
  max-width: calc(100% - 115px);
  flex: 0 1 260px;
  margin-left: 30px;
  color: #f5cfa8;
}

.vip_group_title,
.vip_group_subtitle {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vip_group_title {
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
}

.vip_group_subtitle {
  margin-top: 4px;
  margin-left: 15px;
  color: #f8d3ad;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}

.list {
  margin: 10px 10px 0;
  padding: 5px 12px 5px;
  background: linear-gradient(110deg, #232323, #303030);
}

/deep/ .van-cell {
  min-height: 48px;
  color: var(--text);
  line-height: 48px;
}

/deep/ .van-cell:not(:last-of-type) {
  border-bottom-color: #4a4038;
}

/deep/ .van-cell__right-icon {
  color: var(--muted);
}

.menu-icon {
  color: var(--accent);
}

.custom-title {
  color: var(--text);
  font-weight: 500;
}

.logout-wrap {
  padding-top: 12px;
}

.history_coupon {
  height: 42px;
  border: 0;
  border-radius: 7px;
  background: linear-gradient(120deg, #f5cfa8, #dbab73);
  color: #5a4839;
  box-shadow: 0 6px 14px rgba(0, 0, 0, .22);
}

/deep/ .notice-popup {
  border-color: #75654f;
  border-radius: 9px;
  background: #2c2928;
  color: var(--text);
  box-shadow: 0 12px 28px rgba(0, 0, 0, .35);
}

@media screen and (max-width: 374px) {
  .top_header {
    padding-right: 8px;
    padding-left: 8px;
  }

  .list {
    margin-right: 8px;
    margin-left: 8px;
  }

  .vip_group {
    min-height: 74px;
    margin-right: 10px;
    margin-left: 10px;
    border-radius: 37px;
  }

  .vip_group_txt {
    width: 185px;
    max-width: calc(100% - 90px);
    flex-basis: 185px;
    margin-left: 28px;
  }

  .vip_group_title {
    font-size: 14px;
    line-height: 23px;
  }

  .vip_group_subtitle {
    margin-top: 2px;
    margin-left: 20px;
    font-size: 10px;
    line-height: 15px;
  }

  .profile-main {
    padding: 12px;
  }

  .user_header {
    width: 56px;
    height: 56px;
    flex-basis: 56px;
  }
}
</style>
